(function(){
	"use strict";
	function moveLinks(){
		var secondaryArea = document.querySelector('.thb-secondary-area');
		if(!secondaryArea) return;
		if(secondaryArea.querySelector('.ln-secondary-links')) return; // déjà déplacés
		
		// Trouver les <li> du main menu contenant Journal et About
		var journalLi = null, aboutLi = null;
		document.querySelectorAll('.thb-full-menu > li').forEach(function(li){
			var a = li.querySelector('a');
			if(!a) return;
			var href = a.getAttribute('href') || '';
			if(href === '/blogs/journal' || href.endsWith('/blogs/journal')) journalLi = li;
			if(href === '/pages/about' || href.endsWith('/pages/about')) aboutLi = li;
		});
		if(!journalLi && !aboutLi) return;
		
		// Créer le container secondary à insérer AVANT les icônes
		var ul = document.createElement('ul');
		ul.className = 'ln-secondary-links';
		
		if(journalLi){
			var a = journalLi.querySelector('a');
			var li = document.createElement('li');
			var newA = document.createElement('a');
			newA.href = a.getAttribute('href');
			newA.textContent = a.textContent.trim();
			li.appendChild(newA);
			ul.appendChild(li);
			journalLi.classList.add('ln-moved-hide');
		}
		if(aboutLi){
			var a = aboutLi.querySelector('a');
			var li = document.createElement('li');
			var newA = document.createElement('a');
			newA.href = a.getAttribute('href');
			newA.textContent = a.textContent.trim();
			li.appendChild(newA);
			ul.appendChild(li);
			aboutLi.classList.add('ln-moved-hide');
		}
		
		// Insérer au début de la secondary area (avant les icônes)
		secondaryArea.insertBefore(ul, secondaryArea.firstChild);
	}
	if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',moveLinks);}else{moveLinks();}
	document.addEventListener('shopify:section:load', moveLinks);
})();